import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import PropTypes from 'prop-types';
import GridLoading from '../../../components/grid-loading';
import baseColumns from './columns';
import style from './style.module.less';
import ReportingCategoriesGridPlaceholder from './grid-placeholder';
import { ReportingCategoryContext } from './context';

const CategoryDetail = ({ categoryId }) => {
  const { setNeedsReload } = useContext(ReportingCategoryContext);
  const [idInEditMode, setIdInEditMode] = useState(null);
  const [nameValue, setNameValue] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const name = useSelector((state) =>
    Global.selectEntitiesReportingCategoryPropertyById(state, {
      categoryId,
      property: 'name',
    }),
  );

  return baseColumns.map((column) => (
    <div key={column.id} className={style['item-cell']}>
      {column.render({
        categoryId,
        idInEditMode,
        setIdInEditMode,
        setNeedsReload,
        name,
        nameValue,
        setNameValue,
        errorMessage,
        setErrorMessage,
      })}
    </div>
  ));
};

CategoryDetail.propTypes = {
  categoryId: PropTypes.string.isRequired,
};

const ReportingCategoryGrid = () => {
  const { reportingCategoryIds, isLoading } = useContext(ReportingCategoryContext);

  const isEmptyGrid = !isLoading && reportingCategoryIds.length === 0;
  return (
    <>
      {isEmptyGrid && <ReportingCategoriesGridPlaceholder />}
      <div className={style['reporting-category-container']}>
        {isLoading && <GridLoading />}
        {reportingCategoryIds.map((categoryId, index) => (
          <CategoryDetail key={index} categoryId={categoryId} isLoading={isLoading} />
        ))}
      </div>
    </>
  );
};

export default ReportingCategoryGrid;
